<template>

  <v-container>

    <v-overlay :value="overlay">

      <v-progress-circular indeterminate size="64"></v-progress-circular>

    </v-overlay>

    <v-dialog v-model="verifiedDialog" persistent max-width="500">

      <v-card class="pa-3">

        <v-card-title class="h2">Verification successful</v-card-title>

        <v-card-text class="text-body-1">

          <p>Click OK to login to the system.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="verifiedOk" color="primary">OK</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-dialog v-model="emailAlreadyVerifiedDialog" persistent max-width="500">

      <v-card class="pa-3">

        <v-card-title class="h2">Verification failed</v-card-title>

        <v-card-text class="text-body-1">

          <p>This email address has already been verified.</p>

          <p>Click OK to enter the system or to reset your password.</p>

        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn @click="emailAlreadyVerifiedOkDialog" color="primary">OK</v-btn>

        </v-card-actions>

      </v-card>

    </v-dialog>

  </v-container>

</template>

<script>

import axios from "axios";

export default {

  name: "VerifyEmail",

  methods:
      {
        verifiedOk()
        {
          this.$router.push('/Login');
        },
        emailAlreadyVerifiedOkDialog()
        {
          this.$router.push('/Login');
        }
      },

  created()
  {
    var token = this.$route.query.token;

    this.overlay = true;

    setTimeout( async () => {

          let obj = await axios.get('accounts/VerifyEmail?token=' + token);

          this.overlay = false;

          if (obj.data == '%%EMAIL_ALREADY_VERIFIED%%')
          {

            this.emailAlreadyVerifiedDialog = true;

          }
          else {

            this.verificationStatus = 'verified';

            this.verifiedDialog = true;

          }

        }, 100

    );

  },

  data: () => {

    return {

      overlay: false,

      verificationStatus: 'verifying',

      verifiedDialog: false,

      emailAlreadyVerifiedDialog: false

    }

  }

}

</script>
